module.exports = __webpack_public_path__ + "static/media/music-player.bc78c7cb.jpg";